import type { EngineUseField } from "@shared-core/data/manufacturing-setup-types";
import { Table, TableBody, TableCell, TableRow } from "../../primitives/table";
import { EngineUseBadge } from "./EngineUseBadge";

/**
 * A flat field/value list badged per field — the cost-centre "Rates" sub-tab
 * shape from the design note's own worked example ("Charge rate £99.45/h
 * ● used by engine ..."). Used wherever a detail page shows scalar named
 * fields rather than tabular rows.
 */
export function EngineUseFieldTable({
  fields,
  emptyMessage,
}: {
  fields: EngineUseField[];
  /** Named per caller (cost centre / material / ink profile / part), never
   *  a generic "entity" — see EngineUseRowTable's own emptyMessage prop. */
  emptyMessage: string;
}) {
  if (fields.length === 0) {
    return (
      <p className="rounded-md border border-dashed border-border p-4 text-center text-sm text-muted-foreground">
        {emptyMessage}
      </p>
    );
  }
  return (
    <div className="overflow-x-auto rounded-md border border-border">
      <Table>
        <TableBody>
          {fields.map((f) => (
            <TableRow key={f.key}>
              <TableCell className="font-medium text-muted-foreground w-1/3">
                {f.label}
              </TableCell>
              <TableCell className="tabular-nums">{f.value}</TableCell>
              <TableCell>
                <EngineUseBadge status={f.status} why={f.why} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
